import { useBreakpoints } from '@vueuse/core'
import { BREAKPOINTS } from '@config'
import { computed } from 'vue'

export default function () {
  const breakpoints = useBreakpoints(BREAKPOINTS)
  const twoCardsPerRow = breakpoints.between('xxs', 'sm')
  const threeCardsPerRow = breakpoints.between('sm', 'lg')
  const fourCardPerRow = breakpoints.between('lg', 'xl')
  const fiveCardPerRow = breakpoints.between('xl', '2xl')

  const loadingCardCount = computed(() => {
    if (twoCardsPerRow.value) return 2
    if (threeCardsPerRow.value) return 3
    if (fourCardPerRow.value) return 4
    if (fiveCardPerRow.value) return 5
    return 6
  })

  return {
    loadingCardCount,
  }
}
